import cn from 'clsx'
import { connect } from 'react-redux'
import { motion, AnimateSharedLayout } from 'framer-motion'

// Components
import { Link, Layout } from '@tracklib/kit'

// Types
import { State } from 'types'

import styles from './tabs2.css'

const TabsLoading = () => (
  <>
    <span className={cn(styles.loadingItem, styles.itemActive)} />
    <span className={styles.loadingItem} />
    <span className={styles.loadingItem} />
  </>
)

type Tabs2Props = {
  items: Array<{
    id: number
    to: string
    label: string
    query?: Record<string, string>
  }>
  sticky?: boolean
  location: Location
}

const Tabs2 = ({ items, sticky, location }: Tabs2Props): JSX.Element => (
  <Layout.FullWidth>
    <AnimateSharedLayout transition={{ duration: 0.2 }}>
      <nav className={cn(styles.tabs, sticky && styles.sticky)}>
        {items.length === 0 ? (
          <TabsLoading />
        ) : (
          items.map(item => {
            const isActive = location.pathname === item.to
            return (
              <Link
                key={item.id}
                to={item.to}
                query={item.query ? item.query : undefined}
                className={cn(styles.item, isActive && styles.itemActive)}
              >
                {item.label}
                {isActive && <motion.div layoutId="underline" className={styles.underline} />}
              </Link>
            )
          })
        )}
      </nav>
    </AnimateSharedLayout>
  </Layout.FullWidth>
)

const mapStateToProps = (state: State) => {
  return { location: state.router.location }
}
export default connect(mapStateToProps)(Tabs2)
